var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhBlueTick(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7325 26.4024C21.1388 26.4024 26.3321 21.2091 26.3321 14.8028C26.3321 8.39646 21.1388 3.20312 14.7325 3.20312C8.32615 3.20312 3.13281 8.39646 3.13281 14.8028C3.13281 21.2091 8.32615 26.4024 14.7325 26.4024ZM20.1076 12.9281C20.6738 12.3619 20.6738 11.4438 20.1076 10.8776C19.5413 10.3113 18.6233 10.3113 18.057 10.8776L13.2825 15.6521L11.4079 13.7775C10.8416 13.2112 9.92356 13.2112 9.35731 13.7775C8.79107 14.3437 8.79107 15.2618 9.35731 15.828L12.2572 18.7279C12.8235 19.2942 13.7415 19.2942 14.3078 18.7279L20.1076 12.9281Z",
    fill: "#5D5FEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhBlueTick);
export default __webpack_public_path__ + "static/media/WHBlueTick.0f20584a87bf88f68261f908d065f1ef.svg";
export { ForwardRef as ReactComponent };